import { WeatherActualCondition } from '@ebalance/proto/bffuser/v1/weather_actual_model_pb'

/**
 * 時系列予報 (VPFD, 3 時間粒度) の天気文 5 値の閉集合 → 表示絵文字。
 * SoT: docs/specs/demand/jma-weather-data.md §5 表「3 時間天気（VPFD 5 値）の割当」。
 * 閉集合外 (未知テキスト) は '' (= 空アイコン降格。晴等の既知値へ倒さない、grill Q6)。
 */
export function vpfdEmojiOf(weatherText: string, daytime: boolean): string {
  switch (weatherText) {
    case '晴れ':
      return daytime ? '☀️' : '🌙'
    case 'くもり':
      return '☁️'
    case '雨':
      return '☔'
    case '雪':
      return '❄️'
    case '雨または雪':
      return '☔❄️'
    default:
      return ''
  }
}

/**
 * 実績天気 (WeatherActualCondition) → 表示絵文字。天気アイコン帯の過去区間で使う。
 * backend は夜間 (日照が使えない時) も station 天気コードで SUNNY を導出しうるため、
 * 予報 (vpfdEmojiOf) と同じく晴は昼 ☀️ / 夜 🌙 で切り替える (spec jma-weather-data
 * §5 / AC-WD-011: 晴系は昼 ☀️ / 夜 🌙)。UNSPECIFIED (導出不能・欠測) は '' に降格。
 */
export function weatherActualEmojiOf(
  condition: WeatherActualCondition,
  daytime: boolean,
): string {
  switch (condition) {
    case WeatherActualCondition.SUNNY:
      return daytime ? '☀️' : '🌙'
    case WeatherActualCondition.CLOUDY:
      return '☁️'
    case WeatherActualCondition.RAIN:
      return '☔'
    case WeatherActualCondition.SNOW:
      return '❄️'
    case WeatherActualCondition.UNSPECIFIED:
    default:
      return ''
  }
}
